import { combineReducers } from "redux";
import moduleReducers from "./reducers/modules";

// IMPORTANT : ne pas ajouter directement de reducers ici.
// Ajouter les reducers dans src/app/redux/reducers/modules/<module>Reducers.js
// Garder les mêmes clés Redux pour ne pas casser les selectors existants.
export default function createReducer(injectedReducers = {}) {
  return combineReducers({
    ...moduleReducers,
    ...injectedReducers,
  });
}
